// extracted by mini-css-extract-plugin
export default {"chatFooter":"ul_um","chatFooter__dealer":"ul_un"};